import {
  GET_ATTENDANCE,
  GET_ATTENDANCE_SUCCESS,
  GET_ATTENDANCE_FAIL,
  DELETE_ATTENDANCE,
  DELETE_ATTENDANCE_SUCCESS,
  DELETE_ATTENDANCE_FAIL,
  UPDATE_ATTENDANCE,
  UPDATE_ATTENDANCE_SUCCESS,
  UPDATE_ATTENDANCE_FAIL,
  ADD_NEW_ATTENDANCE,
  ADD_ATTENDANCE_SUCCESS,
  ADD_ATTENDANCE_FAIL,
  ATTENDANCE_LOADING,
  ATTENDANCE_RESET,
} from "./actionType";

export const resetAttendanceState = (actionType) => ({
  type: ATTENDANCE_RESET,
  payload: { actionType },
});

export const getAttendanceSuccess = (actionType, data) => ({
  type: GET_ATTENDANCE_SUCCESS,
  payload: { actionType, data },
});

export const getAttendanceFail = (actionType, error) => ({
  type: GET_ATTENDANCE_FAIL,
  payload: { actionType, error },
});

export const getAttendance = data => ({
  type: GET_ATTENDANCE,
  payload: data,
});

export const getAttendanceLoading = () => ({
  type: ATTENDANCE_LOADING
});

export const deleteAttendance = data => ({
  type: DELETE_ATTENDANCE,
  payload: data,
});

export const deleteAttendanceSuccess = data => ({
  type: DELETE_ATTENDANCE_SUCCESS,
  payload: data,
});

export const deleteAttendanceFail = error => ({
  type: DELETE_ATTENDANCE_FAIL,
  payload: error,
});

export const updateAttendance = data => ({
  type: UPDATE_ATTENDANCE,
  payload: data,
});

export const updateAttendanceFail = error => ({
  type: UPDATE_ATTENDANCE_FAIL,
  payload: error,
});

export const updateAttendanceSuccess = data => ({
  type: UPDATE_ATTENDANCE_SUCCESS,
  payload: data,
});

export const addNewAttendance = data => ({
  type: ADD_NEW_ATTENDANCE,
  payload: data,
});

export const addAttendanceSuccess = data => ({
  type: ADD_ATTENDANCE_SUCCESS,
  payload: data,
});

export const addAttendanceFail = error => ({
  type: ADD_ATTENDANCE_FAIL,
  payload: error,
});